/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import {
  LoyaltyPointsLogo,
  ItemPrice,
  PlusLoyaltyText,
  VipPackageContainer,
  LogoWrapper,
  LogoImage,
  PackageTitleWrapper,
  DurationText,
  PackageTitleText,
  PlusOfferContainet,
  PlusOfferWrapper,
  PlusLogoAndAmountContainer,
  PackagePriceWrapper,
  BuyButtonWrapper,
  Divider,
  Styles,
} from './styledComponents';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { purchaseActionTriggers } from 'shared/constants/userActions';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';
import Button from '../../components/Button/Button';
import generateRender from 'shared/utils/generateRender';
import { TAG } from 'shared/constants';
import useWindowSize from '../../hooks/useWindowSize';

const GREEN_BUTTON = generateRender({
  default: assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY),
  sga: assetSource(ASSET_KEY.ROUNDED_RECT_SECONDARY),
});

export default function StoreVipItems({ item, index, buyHandle, hasVIPPass, unlimitedVipAccess }) {
  const { height: windowHeight } = useWindowSize();

  const logos = [
    assetSource(ASSET_KEY.VIP_TROPHY_ICON_FIRST),
    assetSource(ASSET_KEY.VIP_TROPHY_ICON_SECOND),
    assetSource(ASSET_KEY.VIP_TROPHY_ICON_THIRD),
  ];

  const actionButton = unlimitedVipAccess ? assetSource(ASSET_KEY.ROUNDED_RECT_DISABLED) : GREEN_BUTTON;
  const buttonTextStroke = unlimitedVipAccess ? BUTTON_STROKES.DISABLED : BUTTON_STROKES.GREEN;

  return (
    <VipPackageContainer windowHeight={windowHeight}>
      <LogoWrapper>
        <LogoImage tag={TAG.IMG} src={logos[index]} />
      </LogoWrapper>
      <PackageTitleWrapper>
        <DurationText>{item.duration_friendly_full}</DurationText>
        <PackageTitleText>{`${getText(TEXT_KEY.VIP)} ${getText(TEXT_KEY.ACCESS)}`}</PackageTitleText>
      </PackageTitleWrapper>
      <PlusOfferContainet>
        <Divider />
        <PlusOfferWrapper>
          <PlusLoyaltyText>{getText(TEXT_KEY.PLUS_SYMBOL)}</PlusLoyaltyText>
          <PlusLogoAndAmountContainer>
            <LoyaltyPointsLogo src={assetSource(ASSET_KEY.LOYALTY_ICON)} />
            <PlusLoyaltyText>{item.bonus_loyalty_points || '0'}</PlusLoyaltyText>
          </PlusLogoAndAmountContainer>
        </PlusOfferWrapper>
        <Divider />
      </PlusOfferContainet>
      <PackagePriceWrapper>
        <ItemPrice>{`${getText(TEXT_KEY.CURRENCY_SIGN)}${item.price}`}</ItemPrice>
      </PackagePriceWrapper>
      <BuyButtonWrapper>
        <Button
          imageSource={actionButton}
          imageStyle={Styles.vipPackageBuyButtonImage}
          containerStyle={Styles.vipPackageBuyButtonStyle}
          objectFit="contain"
          textStyle={Styles.buyButtonText}
          textStroke={buttonTextStroke}
          label={getText(TEXT_KEY.BUY)}
          onClick={() =>
            unlimitedVipAccess
              ? hasVIPPass()
              : buyHandle(item.item_id, item.name, 'vip_room_access', item.price, purchaseActionTriggers.STORE_VIP_ITEM)
          }
        />
      </BuyButtonWrapper>
    </VipPackageContainer>
  );
}

